"use client";

import { Info } from "lucide-react";
import { useEffect, useState } from "react";
import { takeBannerHint } from "@/shared/auth/session-controller";
import { Alert, AlertDescription } from "@/shared/components/ui/alert";

const COPY = {
  expired: "Your session ended. Please sign in again.",
  reauth: "Please sign in again to continue.",
} as const;

/**
 * The one line that says why someone landed on /login from inside the app.
 * `forceSignOut` leaves a one-shot hint; this reads and clears it. Read in an
 * effect, not during render, so the static prerender and the first client
 * render agree.
 */
export function SignInAgainNotice() {
  const [hint, setHint] = useState<keyof typeof COPY | null>(null);
  useEffect(() => {
    setHint(takeBannerHint());
  }, []);
  if (!hint) return null;
  return (
    <Alert className="mt-6">
      <Info aria-hidden />
      <AlertDescription>{COPY[hint]}</AlertDescription>
    </Alert>
  );
}
